
// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const faqApi = baseApi.injectEndpoints({

  credentials: "include",
  endpoints: (builder) => ({
    addFaqs: builder.mutation({
      query: (data) => {
        return {
          url: "admin/faqs",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    updateFaqs: builder.mutation({
      query: ({data, slug}) => {
        return {
          url: `admin/faqs/${slug}`,
          method: "PUT",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    deleteFaqs: builder.mutation({
      query: (slug) => {
        return {
          url: `admin/faqs/${slug}`,
          method: "DELETE",
          // body: user,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getAllFaqs: builder.query({
      query: ({ limit, page }) => {
        return {
          url: `admin/faqs?limit=${limit}&page=${page}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    getHelpSupport: builder.query({
      query: ({ limit, page }) => {
        return {
          url: `admin/help-support?limit=${limit}&page=${page}`, // todo:
          method: "GET",
          // headers: {
          //   "Content-type": "application/json; charset=UTF-8",
          // },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
  }),
});

export const {
  useAddFaqsMutation,
  useUpdateFaqsMutation,
  useDeleteFaqsMutation,
  useGetAllFaqsQuery,
  useGetHelpSupportQuery,
} = faqApi;